import React from 'react';

const CalendarOffChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fill="#020202"
            d="M12.7 10.5L6.9 4.9v-.4h2v2h6v-2h2v2h2v9.9l-2-1.9v-4h-4.2zm3.1 7l-7.2-7H6.9v7h8.9zM4.9 6.9L3.1 5.2l1-1 16.5 15.9-1 1-1.7-1.6h-13V6.9z"
        />
    </svg>
);

CalendarOffChunkySvg.displayName = 'CalendarOffChunkySvg';
export default CalendarOffChunkySvg;
